import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { config } from '../../config/config';
import { getEnv } from '../utility';
import { BaseHttpService } from 'src/app/shared/base-http/base-http.service';


@Injectable()
export class LoginApiService {
   constructor(private readonly baseHttpService: BaseHttpService) { }

   public get(): Observable<any> {
      const url = `${config.tprecmApiBaseUrl[getEnv()]}login`;
      return this.baseHttpService.get(url);
   }
}
